module.exports = __webpack_public_path__ + "static/media/09.2404c56e.jpg";